document.addEventListener("scroll", () => {
  const headerFixed = document.getElementById("header-fixed");
  if (!headerFixed) return;
  headerFixed.style.transform =
    window.pageYOffset >= 95 ? "translateY(0)" : "translateY(-100%)";
});
